export function formatDurationFromDays(days?: number | null): string {
  if (!days || days <= 0) return '';

  const wholeYears = getExactYears(days);
  if (wholeYears !== null) return formatUnit(wholeYears, 'year');

  const wholeMonths = getExactMonths(days);
  if (wholeMonths !== null) return formatUnit(wholeMonths, 'month');

  return formatUnit(days, 'day');
}

export function formatInstallmentFrequency(duration?: number, installments?: number): string {
  if (!duration || !installments) return '';

  const frequency = duration / installments;
  if (!isFinite(frequency) || frequency <= 0) return '';

  if (!Number.isInteger(frequency)) {
    return formatUnit(Math.round(frequency), 'day');
  }

  return formatDurationFromDays(frequency);
}

function getExactYears(days: number): number | null {
  if (days % 365 === 0) return days / 365;
  if (days === 366) return 1;
  return null;
}

function getExactMonths(days: number): number | null {
  if (days % 30 === 0) return days / 30;
  if (days % 31 === 0) return days / 31;
  return null;
}

function formatUnit(value: number, unit: string): string {
  const normalized = Number.isInteger(value) ? value : Number(value.toFixed(1));
  if (normalized === 1 && (unit === 'month' || unit === 'year')) return unit;
  return `${normalized} ${unit}${normalized === 1 ? '' : 's'}`;
}
